module.exports = __webpack_public_path__ + "static/media/un.3835716f.svg";